import { colors, Divider, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import useReactRouter from 'use-react-router';
import { LoadingOverlay } from '../../../components/LoadingOverlay';
import { Page } from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import { Report } from '../../../graphql/reports.datatypes';
import ReportQueryBuilder from './ReportQueryBuilder';
import getReportByKey from './getReportByKey.api';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
}));

const ReportDetails = () => {
  const {history, match}: RouteComponentProps<{ key: string }> = useReactRouter();
  const classes = useStyles();
  const {key} = match.params;
  const isNewItem = key === 'new';
  const title = 'Report';
  const newReportData: Report = {
    id: -1,
    name: '',
    query: '',
    url_key: '',
    shared: false,
  };

  const reportData = isNewItem ? {loading: false, data: null, error: null} : getReportByKey(key);
  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    if (reportData.error) {
      enqueueSnackbar(`There was an error loading Report with key ${key}`, {variant: 'error'});
      history.push('/dashboard');
    }
  }, [reportData.error]);

  return (
    <Page className={classes.root} title={title}>
      <PageHeader section="Reports" title={title}/>
      <Divider className={classes.divider}/>
      <LoadingOverlay loading={reportData.loading}>
        {!reportData.loading && reportData.data && reportData.data.reportByKey && (
          <ReportQueryBuilder report={reportData.data.reportByKey}/>
        )}
        {isNewItem && (
          <ReportQueryBuilder report={newReportData}/>
        )}
      </LoadingOverlay>
    </Page>
  );
};

export default ReportDetails;
